import { useMemo } from 'react';
import { semesters as CONST_SEMESTERS } from 'keys';
import { rating1, rating2, rating3, rating4, rating5, dark } from 'styles/theme';

const useDistributionGraphData = (graph, distributionFilters) => {
    const { ratings_thresholds, student_assessments } = graph || {};

    // 1. חישוב הסמסטרים
    const semesters = useMemo(() => {
        const yearsFilter = distributionFilters?.school_year;
        if (!yearsFilter) return [];

        const generated = [];

        yearsFilter.forEach(yearItem => {
            const year = parseInt(yearItem?.id || yearItem, 10);

            CONST_SEMESTERS.forEach(sem => {
                const startMonth = parseInt(sem.range[0].start.split('-')[0], 10);
                const endMonth = parseInt(sem.range[0].end.split('-')[0], 10);

                const actualStartYear = startMonth >= 9 ? year - 1 : year;
                const actualEndYear = endMonth >= 9 ? year - 1 : year;

                generated.push({
                    id: `${year}-${sem.id}`,
                    name: sem.label,
                    startDate: `${actualStartYear}-${sem.range[0].start}T00:00:00Z`,
                    endDate: `${actualEndYear}-${sem.range[0].end}T00:00:00Z`,
                    schoolYear: year
                });
            });
        });

        return generated;
    }, [distributionFilters?.school_year]);

    // 2. חישוב נתוני הגרף (Datasets)
    // חישוב נתוני הגרף (Datasets)
    const datasets = useMemo(() => {
        if (!graph || !semesters || semesters.length === 0) return [];

        // 1. בניית מערך נקודות הזמן בצורה נקייה וליניארית
        // לוקחים את כל תאריכי ההתחלה של הסמסטרים (שנה אחת = 3 נקודות, שתי שנים = 6 נקודות)
        const timePoints = semesters.map(sem => sem.startDate);

        // מוסיפים את תאריך הסיום אך ורק לסמסטר האחרון של השנה האחרונה
        const lastSemester = semesters[semesters.length - 1];
        if (lastSemester && lastSemester.endDate) {
            timePoints.push(lastSemester.endDate);
        }

        // כעת המערך timePoints מכיל בדיוק:
        // לשנה אחת -> 4 נקודות זמן
        // לשתי שנים -> 7 נקודות זמן
        // זה תואם ב-100% לכמות הערכים שמגיעה מהשרת!

        const ratingColors = [rating1, rating2, rating3, rating4, rating5];

        const ratingDatasets = ratings_thresholds?.map((threshold, index) => {
            // מיפוי ישיר ואינדקס מול אינדקס ללא שום מפות או סיבוכים
            const dataPoints = timePoints.map((xVal, i) => ({
                x: xVal,
                y: threshold.values[i] !== undefined
                    ? threshold.values[i]
                    : threshold.values[threshold.values.length - 1] || 0
            }));

            return {
                label: `דירוג ${threshold.level}`,
                data: dataPoints,
                fill: false,
                backgroundColor: ratingColors[index],
                borderColor: ratingColors[index],
                borderWidth: 1.5,
                pointRadius: 0,
                pointHitRadius: 0
            };
        }) || [];

        // בניית קו ביצועי התלמיד
        const studentDataPoints = student_assessments?.map(assessment => ({
            x: assessment.date,
            y: assessment.score,
            originalData: assessment
        })) || [];

        const studentDataset = {
            label: 'ביצועי התלמיד',
            data: studentDataPoints,
            fill: false,
            backgroundColor: dark,
            borderColor: dark,
            borderWidth: 4,
            pointRadius: 5,
        };

        return [studentDataset, ...ratingDatasets];
    }, [graph, semesters]);

    return { semesters, datasets };
};

export default useDistributionGraphData